import { render, staticRenderFns } from "./OneCol.vue?vue&type=template&id=7a0d6c92"
import script from "./OneCol.vue?vue&type=script&lang=js"
export * from "./OneCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports